import type { AuthSession, AuthTokens } from 'aws-amplify/auth';

/**
 * Builds the `Authorization: Bearer <token>` header value from a v6
 * `fetchAuthSession()` result (`AuthService.currentSession()`).
 *
 * Extracted out of `helper.ts` on purpose: `helper.ts` imports `../routes`,
 * which transitively imports `routes/Root.tsx` — still on the v5
 * `@aws-amplify/auth` import until PR3 lands (UES-12140). Keeping this pure
 * transformation in its own module means it stays unit-testable today,
 * independent of that unrelated, already-flagged PR3 import chain.
 */
export const getBearerToken = (session: AuthSession) =>
  `Bearer ${session.tokens?.accessToken?.toString() ?? ''}`;

/**
 * Reads the access token's `exp` claim off a v6 `fetchAuthSession()` result,
 * used by `helpers/sessionTracker.js` to schedule automatic sign-out.
 * v5's session carried the same `accessToken.payload.exp` shape, but with
 * `accessToken` as a top-level session property instead of `tokens.accessToken`.
 */
export const getAccessTokenExpiry = (session: { tokens: AuthTokens }) =>
  session.tokens.accessToken.payload.exp;
